export default __webpack_public_path__ + "static/media/Group.f85562c8.svg";